// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = '1.0.4';
export const REVISION = 1662;
export const TTL = 1;
/* tslint:enable */
